import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { FormValue } from '../type';
import { formatDisplay } from '@/utils/format-display';

// ROI% relative to margin (already leverage-scaled, see calculateTPSLV2.percentToPrice).
// Matches the app's hard cap on Take Profit (see useTPSLV2's errorTP: "Take profit cannot exceed 900%").
export const MAX_TP_PERCENT = 900;

export function PotentialEarningCard(props: {
    amount: number;
    leverage: number;
    className?: string;
    takeProfit:string
}) {
    const { amount, leverage, className ,takeProfit} = props;
    const { t } = useTranslation();
    if (!amount || !leverage || !takeProfit) return null;

    const potentialEarning = (amount * Number(takeProfit)) / 100;

    return (
        <div
            className={clsx(
                'rounded-2xl border border-green-500/30 bg-green-500/10 px-4 py-3 text-center',
                className
            )}
        >
            <p className="text-[10px] font-bold uppercase tracking-wider text-green-500">
                {t('Potential Earning')}
            </p>
            <p className="text-2xl font-extrabold text-green-500">
                +
                {formatDisplay(potentialEarning, {
                    decimalToShow: 2,
                    minimumDecimalToShow: 2,
                })}{' '}
                WLD
            </p>
            <p className="text-xs text-green-500/80">
                {t('If Take Profit +{{percent}}% is reached', {
                    percent: formatDisplay(Number(takeProfit), {
                        decimalToShow: 0,
                    }),
                })}
            </p>
        </div>
    );
}

export function PotentialEarning() {
    const { control } = useFormContext<FormValue>();
    const [amount, leverage, tp] = useWatch({
        control,
        name: ['amount', 'leverage', 'tp'],
    });


    return (
        <PotentialEarningCard amount={Number(amount)} leverage={leverage} takeProfit={tp}/>
    );
}
